import React, { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../../../context/AppContext";
import { postRequest, simpleGetCall, simplePatchCall, simplePostCall } from "../../../api/ApiServices";
import { useReactToPrint } from "react-to-print";
import { Spinner } from "react-bootstrap";
import {
  Download,
 
} from "lucide-react";
import { notifyError, notifySuccess } from "../../../toaster/notify";
import StoreSelector from "../../StoreSelector";
// import ApiConfig from "../../../api/ApiConfig";

const PrintList = () => {
  const {
    sidebar,
    selectedStoreID,
    selectedRestID,
    SelectedRestName,
    setSelectedStoreID, 
    storesList,
    ApiConfig,
    permissions
  } = useContext(AppContext);

  const reportRef = useRef(null);
 const handlePrint = useReactToPrint({
  contentRef: reportRef,
  documentTitle: `Executive_Sales_Report_${SelectedRestName || "Report"}`,
  removeAfterPrint: true,
});
  const [dataItems, setDataItems] = useState(null);
  
    const [loadingExport, setLoadingExport] = useState(false);
  const [res, setRes] = useState({});
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  
  const [selectedDateTo, setSelectedDateTo] = useState(
    new Date().toISOString().split("T")[0]
  );

  useEffect(() => {
  fetchDataDropDwon()
    if (selectedDate && selectedDateTo && selectedStoreID) {
      fetchStatusList(selectedDate, selectedDateTo);
    }
  }, [selectedDate, selectedDateTo, selectedStoreID, selectedRestID]);
  const [reportLoading , setReportLoading] = useState(false);
 const [data, setData] = useState([]); // Array to store kitchens
  const fetchStatusList = async (date, dateTo) => {
    setReportLoading(true);
    try {
      const res = await simpleGetCall(
        `https://zamzam.crm-api.wifiattendance.com:3016/api/v1/order/daily-sales-report?shop_id=${selectedStoreID}&start_date=${date}&end_date=${dateTo}`
      );
      if (res.success) {
        setDataItems(res.data);
        setRes(res);
      }
    } catch (err) {
      console.error("Status API Error:", err);
    } finally {
      setReportLoading(false);
    }
  };

const fetchDataDropDwon= async () => {
  try {
    const res = await simpleGetCall(`${ApiConfig.List_Print}${selectedStoreID}`);
    // Based on your snippet, res.data contains the array of kitchens
    setData(res.data); 
  } catch (error) {
    console.error("Error fetching store data:", error);
  }
};

  if (!selectedStoreID ) {
    return (
      <div className={sidebar ? "taskMain" : "cx-active taskMain"} id="cx-main">
  <div className="role-content">

          <div className="text-center">
            {" "}
            <p>Please select a restaurant</p>{" "}
          </div>
          </div>
          </div>
          )
  }     
  

  if (!dataItems) return <div>Loading...</div>;

  // const Row = ({ label, value }) => (
  //   <div style={{ display: "flex", justifyContent: "space-between" }}>
  //     <span>{label}</span>
  //     <span>{value}</span>
  //   </div>
  // );


  const Row = ({ label, value, bold = false }) => {
  const isCurrency = typeof value === "string" && value.includes("₹");



  return (
    <div
      className="d-flex align-items-center py-2 px-2 report-row"
      style={{
        borderBottom: "1px dashed #e5e7eb",
        transition: "background 0.2s ease",
      }}
    >
      {/* Label Column */}
      <div
        style={{
          flex: 1,
          fontSize: "0.9rem",
          color: "#374151",
          fontWeight: bold ? 600 : 500,
        }}
      >
        {label}
      </div>

      {/* Currency Column */}
      <div
        style={{
          width: "180px",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          alignItems: "center",
          justifyContent: "end",
          columnGap:'4px',
          fontVariantNumeric: "tabular-nums",
          fontWeight: bold ? 700 : 500,
          color: bold ? "#111827" : "#1f2933",
        }}
      >
        <span style={{ textAlign: "right", fontFamily:'sans-serif' }}>
          {isCurrency ? "₹" : ""}
        </span>
        <span style={{ textAlign: "left" }}>
          {isCurrency ? value.replace("₹", "") : value}
        </span>
      </div>
    </div>
  );
};

  const Section = ({ title, children }) => (
  <div className="mb-4 print-section">
    <div
      className="px-3 py-2 rounded-2 mb-2"
      style={{
        background: "#e0ecf4",
        border: "1px solid #DDEAF3",
      }}
    >
      <h6 className="mb-0 fw-semibold text-dark">{title}</h6>
    </div>
    <div className="px-2">{children}</div>
  </div>
);

const TripleRow = ({ title, orders, sales }) => {
  return (
    <div
      className="d-flex align-items-center py-2 px-2 report-row"
      style={{
        borderBottom: "1px dashed #e5e7eb",
        fontVariantNumeric: "tabular-nums",
      }}
    >
      {/* Title */}
      <div
        style={{
          flex: 1,
          fontSize: "0.9rem",
          fontWeight: 500,
          color: "#374151",
        }}
      >
        {title}
      </div>

      {/* Orders */}
      <div
        style={{
          width: "100px",
          textAlign: "center",
          // fontWeight: 600,
          color: "#111827",
        }}
      >
       Orders : {orders}
      </div>

      {/* Sales */}
      <div
        style={{
          width: "180px",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          columnGap:'4px',
          justifyContent: "end",
          // fontWeight: 600,
        }}
      >
        <span style={{ textAlign: "right" , fontFamily:'sans-serif' }}>₹</span>
        <span style={{ textAlign: "left" }}>{sales}</span>
      </div>
    </div>
  );
};



  function downloadExcelFromResponse(response, fileName = "report.xlsx") {
    setLoadingExport(true);
    response.blob().then((blob) => {
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);
    });

    setLoadingExport(false);
  }
  const getSalesReportExport = async () => {
    setLoadingExport(true);
    if (!selectedStoreID) {
      notifyError("Please select a restaurant");
      setLoadingExport(false);
      return;
    }

    try {
      const response = await fetch(
        ` ${ApiConfig?.GET_SALES_EXECUTIVE_REPORT_EXPORTS}?shop_id=${selectedStoreID}&start_date=${selectedDate}&end_date=${selectedDateTo}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("Token"),
          },
        }
      );

      if (!response.ok) {
        throw new Error("Download failed");
      }

      downloadExcelFromResponse(response, "reports.xlsx");
    } catch (err) {
      notifyError("Something went wrong");
      console.error("Status API Error:", err);
    } finally {
    
    }
  };


 


const DonloadReport = async (kitchenId) => {
  setLoadingExport(true); // Start spinner
  try {
    const requestBody = {
      "shop_id": selectedStoreID,
      "start_date": selectedDate,
      "end_date": selectedDateTo,
      "kitchen_id": kitchenId // This is now dynamic from the dropdown selection
    };

    const res = await postRequest(
      `${ApiConfig?.IMPORT_executive}`,
     JSON.stringify(requestBody)
    );

    if (res.success) {
      notifySuccess(res.message || "Report downloaded successfully!");
    } else {
      console.error("API Error:", res.message);
    }
  } catch (err) {
    console.error("Status API Error:", err);
  } finally {
    setLoadingExport(false); // Stop spinner
  }
};

  if (reportLoading) {
    return (
      <div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
      >
        <div className="role-content">
          <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
            <div className="text-center">
              <div className="spinner-border text-primary mb-2" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>

              <p className="text-secondary small">Loading  Report...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
 
    // </div>



    // NEW UI

    <div className={sidebar ? "taskMain" : "cx-active taskMain"} id="cx-main">
  <div className="role-content">
  {!selectedStoreID ? (
          <div className="text-center">
            {" "}
            <p>Please select a restaurant</p>{" "}
          </div>
        ) : (

  <div
    className="bg-white rounded-4 p-4 shadow-sm"
     ref={reportRef}
     id="print-report"
    style={{
      Width: "100%",
      margin: "0 auto",
      border: "1px solid #e5e7eb",
      fontFamily: "Inter, system-ui, sans-serif",
    }}
  >
    {/* <div  ref={reportRef}
     id="print-report">  */}
    {/* Header */}
    <div className="d-flex justify-content-between align-items-center mb-4">
      <div>
        <h4 className="mb-1 fw-semibold">{SelectedRestName}</h4>
        <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
          Executive Sales Report —{" "}
          {dataItems?.sale_date
            ? new Date(dataItems?.sale_date).toLocaleDateString()
            : ""}
        </p>
        
      </div>

  <div className="">
     <span>Select Restaurants:</span>
 {permissions && permissions["View Sales Executive Report"] && (
            <StoreSelector
              options={Array.isArray(storesList) ? storesList.map(store => ({
                value: store.value,
                label: store.label,
              })) : []}
              value={selectedStoreID}
              onChange={(value) => {
                setSelectedStoreID(value);
                localStorage.setItem("selectedStoreId", value);
              }}
            />
          )}
  </div>


      {/* Date Controls */}
      <div className="d-flex gap-3">
        <div>
          <label className="form-label mb-1 text-muted small">
            From Date
          </label>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="form-control form-control-sm"
          />
        </div>

        <div>
          <label className="form-label mb-1 text-muted small">
            To Date
          </label>
          <input
            type="date"
            value={selectedDateTo}
            onChange={(e) => setSelectedDateTo(e.target.value)}
            className="form-control form-control-sm"
          />
        </div>
      </div>
    </div>

    {/* Meta Info */}
    <div className="d-flex justify-content-between mb-3">

<div className="d-flex align-items-center gap-2">
   <button
  onClick={handlePrint}
  className="btn btn-sm d-flex align-items-center  no-print"
  style={{
    background: "#111827",
    color: "#fff",
    borderRadius: "8px",
    padding: "6px 24px",
  }}
>
  🖨️ Print
</button>


                    <button
                      className=" no-print btn btn-primary btn-sm d-flex align-items-center gap-2 shadow-sm  w-md-auto justify-content-center"
                      onClick={getSalesReportExport}
                      disabled={loadingExport}
                      style={{padding:'6px', width:'175px' }}
                    >
                      <Download size={14} />
                      {loadingExport ? <Spinner size="sm" /> : "Download Excel"}
                    </button>
               <div className="dropdown">
  <button
    className="btn btn-primary btn-sm dropdown-toggle d-flex align-items-center gap-2 shadow-sm justify-content-center"
    type="button"
    id="dropdownMenuButton"
    data-bs-toggle="dropdown" 
    aria-expanded="false"
    style={{ width: '200px', padding: '6px' }}
    disabled={loadingExport}
  >
    <Download size={14} />
    {loadingExport ? "Processing..." : "Thermal Print"}
  </button>
 
  <ul className="dropdown-menu shadow" aria-labelledby="dropdownMenuButton">
    {data?.length > 0 ? (
      data?.map((item) => (
        <li key={item.id}>
          <button 
            className="dropdown-item" 
            onClick={() => DonloadReport(item.id)} // Pass the kitchen ID here
          >
            {item.kitchen_name}
          </button>
        </li>
      ))
    ) : (
      <li><span className="dropdown-item disabled">No Kitchens Found</span></li>
    )}
  </ul>
</div> {" "}

</div>

      <div className="text-muted small text-end">
        <div>
          <strong className="text-dark">Restaurant :</strong>{" "}
          {dataItems?.restaurant_name}
        </div>
        <div>
          <strong className="text-dark">Invoice :</strong>{" "}
          {res?.invoiceRange || " "}
        </div>
      </div>
    </div>

    {/* Section Divider */}
    <div className="border-top mb-3" />

    {/* Billing Success */}
    <Section title="Billing (Success)">
      <Row label="Order Count" value={dataItems.total_orders} />
      <Row label="Sub Total" value={`₹${dataItems.sub_total}`} />
      <Row label="Discount" value={`₹${dataItems.discount_amount}`} />
      <Row
        label="Delivery Charge"
        value={`₹${dataItems.total_delivery_charges}`}
      />

      <Row
        label="Delivery Charges On 5% GST"
        value={`₹${dataItems.delivery_gst || 0}`}
      />
      <Row
        label="Service Charge"
        value={`₹${dataItems.total_service_charges}`}
      />
      <Row
        label="Container Charge"
        value={`₹${dataItems?.packing_charges || 0}`}
      />
      <Row label="CGST" value={`₹${dataItems.cgst}`} />
      <Row label="SGST" value={`₹${dataItems.sgst}`} />
      
      <Row label="TDS" value={`₹${dataItems?.tds || 0}`} />
      <Row label="Round Off" value={`₹${dataItems.round_off}`} />
      <Row label="Waived Off" value={`₹${dataItems?.waived_off || 0}`} />

      <div className="border-top my-2" />

      <Row
        label="Grand Total"
        value={`₹${dataItems.total_sales}`}
        bold
      />
      <Row label="Net Sales" value={`₹${dataItems?.net_sale || 0}`} bold />

      {/* Razorpay Only */}
      {dataItems.payment_methods_data
        ?.filter((p) => p.payment_type.toLowerCase() === "razorpay")
        .map((p, idx) => (
          <Row
            key={idx}
            label="Razorpay"
            value={`Orders: ${p.total_orders}, ₹${p.total_sales}`}
          />
        ))}
    </Section>

    {/* Billing Cancel */}
    <Section title="Billing (Cancel)">
      <Row label="Order Count" value={dataItems.total_cancelled_orders} />
      <Row
        label="Amount"
        value={`₹${dataItems.total_cancelled_amount}`}
      />
    </Section>

    {/* Order Type */}
    {/* <Section title="Order Type">
      
      {dataItems.order_types_data?.map((o, idx) => (
        <Row
          key={idx}
          label={
            o.order_type === "P"
              ? "Takeaway"
              : o.order_type === "H"
              ? "Home Delivery"
              : o.order_type
          }
          value={`Orders: ${o.total_orders}, ₹${o.total_sales}`}
        />
      ))}
    </Section> */}


    <Section title="Order Type">
  

  {dataItems.order_types_data?.map((o, idx) => (
    <TripleRow
      key={idx}
      title={
        o.order_type === "P"
          ? "Takeaway"
          : o.order_type === "H"
          ? "Home Delivery"
          : o.order_type
      }
      orders={o.total_orders}
      sales={o.total_sales}
    />
  ))}
</Section>


    {/* Payment Mode */}
    <Section title="Payment Mode">
      {dataItems.payment_methods_data?.map((p, idx) => (
     
         <TripleRow
      key={idx}
      title={p.payment_type.toUpperCase()}
      orders={p.total_orders}
      sales={p.total_sales}
    />
      ))}
    </Section>

    {/* Returns */}
    <Section title="Sales Returns">
      <Row
        label="Returned Orders"
        value={dataItems.total_returned_orders}
      />
      <Row
        label="Returned Amount"
        value={`₹${dataItems.total_returned_amount}`}
       
      />
    </Section>
  </div>
        )}
</div>
</div>

// </div>

  );
};

export default PrintList;
